// BM-H4878: what the Pipeline Tracker row of an older matter shows per stage:
// whether the step is on record, and whether CaseMinder found a file for it
// in the matter's SharePoint folder. One read per matter, shared by the
// seven stage cells (a module cache), so expanding a row walks the folder
// once. Read only: nothing is recorded from here.
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../config/api";

const cache = new Map();

function load(ref) {
  if (!cache.has(ref)) {
    const base = `${API}/pipeline/pre-caseminder/${encodeURIComponent(ref)}`;
    const p = Promise.all([
      Promise.resolve().then(() => axios.get(`${base}/history`)).then((r) => r?.data || null).catch(() => null),
      // A folder that cannot be read is shown as unknown, never as empty.
      Promise.resolve().then(() => axios.get(`${base}/folder-evidence`)).then((r) => r?.data || null).catch(() => null),
    ]).then(([history, found]) => ({ history, found }));
    // A failed read is not cached, so the next expand tries again.
    p.then((v) => { if (!v.history || !v.found) cache.delete(ref); });
    cache.set(ref, p);
  }
  return cache.get(ref);
}

export function clearPreCmFolderStateCache() {
  cache.clear();
}

export function usePreCmFolderState(ref) {
  const [state, setState] = useState(null);
  useEffect(() => {
    let live = true;
    if (ref) load(ref).then((v) => { if (live) setState(v); });
    return () => { live = false; };
  }, [ref]);
  return state;
}
